import { Component, OnInit} from '@angular/core';

@Component({
    selector: 'footer-cmp',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit {
  test : Date;
  constructor() { }

  ngOnInit() {
    this.test = new Date();
  }
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts